// extracted by mini-css-extract-plugin
export var container = "Copywrite-module--container--2aFrZ";
export var container__list = "Copywrite-module--container__list--3YoNq";